import { ResourceLibraryItemCreationPayload } from "@design-controls/types";
import { useMutation } from "react-query";
import { ResourceLibraryAPI } from "../../api/resourceLibrary";
import { useCurrentUser } from "@qualio/ui-components";
import { getQRI } from "@qualio/search-qri";

export const useCreateResourceLibraryProduct = () => {
  const { companyId } = useCurrentUser();
  return useMutation({
    mutationFn: async ({
      displayId,
      name,
    }: ResourceLibraryItemCreationPayload) => {
      const { id } = await ResourceLibraryAPI.createProduct(
        companyId,
        displayId,
        name,
      );
      const product = await ResourceLibraryAPI.getProductById(companyId, id);

      return {
        ...product,
        matrixQRI: buildVersionlessProductQri(
          companyId,
          product.registry_item_matrix_id,
        ),
      };
    },
  });
};

const buildVersionlessProductQri = (
  companyId: number,
  matrixId: string,
): string =>
  getQRI({
    qriBaseUrl:
      import.meta.env.VITE_QRI_SERVICE_PUBLIC_URL ??
      import.meta.env.VITE_QRI_SERVICE_HOSTNAME,
    domain: "registry",
    domainType: "registry-item",
    companyId: companyId.toString(10),
    id: matrixId,
  });
